<template>
    <div class="products-list__item" v-if="product != undefined" >
        <div class="product-card">
            <div class="product-card__image">
                <div class="image image--type--product modal-thumbnail">
                    <!-- <router-link :to="(product.IMKITM == 'Y') ? '/kit-group/' + product.manufacturer + '/' + clearProductName : '/part/' + product.manufacturer + '/' + clearProductName + '/' + product.mfgSeo + '/' + product.itemSeo" class="image__body" v-if="productValid">
                        <img class="image__tag" :src="resource_img" alt="" />
                    </router-link> -->
                    <a href="#" class="image__body" v-if="resource_img != null">
                        <img class="image__tag" :src="resource_img" alt=""  />
                    </a>
                </div>
            </div>
            <div class="cart-table__quantity-search-results product-card__stock-text-search-whi-product-qty">
                <base-quantity-input v-model="quantity" v-if="product.IMKITM != 'Y'"></base-quantity-input>
                <div v-else class="cart-table__quantity input-number"> </div>
            </div>
            <button class="product-card__addtocart-icon product-card__addtocart-icon-whi product-card__stock-text-search-whi-product-btn-cart" type="button" aria-label="Add to cart" @click="addToCart()" v-if="product.IMKITM != 'Y'">
                <svg width="20" height="20">
                    <circle cx="7" cy="17" r="2"></circle>
                    <circle cx="15" cy="17" r="2"></circle>
                    <path
                        d="M20,4.4V5l-1.8,6.3c-0.1,0.4-0.5,0.7-1,0.7H6.7c-0.4,0-0.8-0.3-1-0.7L3.3,3.9C3.1,3.3,2.6,3,2.1,3H0.4C0.2,3,0,2.8,0,2.6
                        V1.4C0,1.2,0.2,1,0.4,1h2.5c1,0,1.8,0.6,2.1,1.6L5.1,3l2.3,6.8c0,0.1,0.2,0.2,0.3,0.2h8.6c0.1,0,0.3-0.1,0.3-0.2l1.3-4.4
                        C17.9,5.2,17.7,5,17.5,5H9.4C9.2,5,9,4.8,9,4.6V3.4C9,3.2,9.2,3,9.4,3h9.2C19.4,3,20,3.6,20,4.4z">
                    </path>
                </svg>
            </button>
            <div class="product-card__info">
                <div class="product-card__name">
                    <div class="product-card__badges"></div>
                    <div>
                        <!-- qo product desc -->

                        <!-- KIT MASTER PRODUCT -->
                        <router-link 
                            v-if="productValid && sourcePage != 'SearchResults' && product.IMKITM == 'Y'" class="cart-table__product-name" :to="'/kit-group/' + product.manufacturer + '/' + clearProductName" style="word-break: break-word;">
                            <!-- {{(product.description != '') ? product.description : product.item_description}} -->
                            {{ product.sku }}
                        </router-link>

                        <!-- NON-KIT PRODUCT -->
                        <router-link 
                            v-if="productValid && sourcePage != 'SearchResults'  && product.IMKITM != 'Y'" class="cart-table__product-name" :to="'/part/' + product.manufacturer + '/' + clearProductName +'/' + product.mfgSeo + '/' + product.itemSeo" style="word-break: break-word;">
                            <!-- {{(product.description != '') ? product.description : product.item_description}} -->
                            {{ product.sku }}
                        </router-link>

                        <!-- whi product desc -->
                        <a v-if="storeCatalog === 'WHI' && productValid && isSearchResPage" class="cart-table__product-name" href="#" @click="setWHIProduct()">
                            {{product.description}}
                        </a>
                        <span v-if="storeCatalog === 'WHI' && !productValid && isSearchResPage" class="cart-table__product-name">
                            {{product.description}}
                        </span>

                        <!-- partslink product desc -->
                        <router-link v-if="storeCatalog === 'PARTSLINK' && productValid && isSearchResPage" class="cart-table__product-name" :to="'/partslink-details/' + product.manufacturer + '/' + clearProductName">
                            {{product.description}} DESC
                        </router-link>
                        <span v-if="storeCatalog === 'PARTSLINK' && !productValid && isSearchResPage" class="cart-table__product-name">
                            {{product.description}} DESC 2
                        </span>

                        <div class="text-cart-item-number">
                            <span class="text-cart-item-number">Item: {{ product.sku }}</span>
                        </div>
                        
                        <!-- <div class="block-brands__item-short-description">
                            <font class="text-cart-item-short-decription">
                                {{(product.description != '') ? product.description : product.item_description}}
                            </font>
                        </div> -->

                        <div class="text-cart-item-manufacturer" v-if="searchBy == 'QO'">
                            <font class="text-cart-item-manufacturer">{{ product.manufacturerdesc }}</font>
                        </div>

                        <div class="text-cart-xref-number" v-if="product.XRITMC">
                            <font class="text-cart-xref-number">({{xref_mfgc}}: {{product.XRITMC}})</font><br>
                        </div>
                        <div class="block-brands__item-alternates-available" v-if="searchBy == 'QO'">
                            <router-link :to="'/compare-substitutes/' + product.manufacturer + '/' + clearProductName" v-if="product.HASSUBST == 'Y'">
                                View Alternate Products
                            </router-link>
                        </div>
                        <div v-else>
                            <div class="text-cart-item-manufacturer">
                                <font class="text-cart-item-manufacturer">
                                    <font class="text-product-facet-category">Manufacturer:</font> {{ product.manufacturerdesc }}
                                </font>
                            </div>
                            <div class="btn btn-sm btn-dark-blue btn-check-stock" v-if="hasRelatedItems === true">
                                <a @click="goToRelated" href="#">
                                    Select Related Items
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-card__information qo-information">
                    <ul class="search-results--bullets" v-for="(desc, i) in product.txt_list" :key="i">
                        <li v-html="desc.ETXITUSE"></li>
                    </ul>
                </div>
                <div class="product-card__information" v-if="searchBy != 'QO'">
                    <ul class="search-results--bullets" v-if="storeCatalog === 'WHI'">
                        <li v-if="product.smartpage_url !== ''"><a class="search-results--links" href="#" @click.prevent="openSmartPageDialog">Smart Page</a></li>
                        <li><router-link class="search-results--links" :to="'/interchange/' + clearProductName">Interchange</router-link></li>
                        <li><router-link class="search-results--links" :to="'/buyers-guide/' + product.QMFRCD + '/' + product.QITEMC + '/' + product.QTYPEC ">Buyer's Guide</router-link></li>
                        <!-- <li><a class="search-results--links" href="#" @click="goToRelated" >Related</a></li> -->
                    </ul>
                    <ul class="search-results--bullets" v-if="storeCatalog === 'PARTSLINK'">
                        <li  v-if="product.OE_number != ''"><a href="#">OE: {{product.OE_number}}</a></li>
                        <li v-if="product.yr_range != ''"><a href="#">Yrs.: {{product.yr_range}}</a></li>
                        <li v-if="isCapaCert == true"><a href="#">CAPA Certified</a></li>
                        <li v-if="isNSFCert == true"><a href="#">NSF Certified</a></li>
                        <li><router-link class="search-results--links" :to="'/buyers-guide/' + product.manufacturer + '/' + product.sku + '/' + product.OE_number ">Buyer's Guide</router-link></li>
                    </ul>
                </div>
                <div class="product-card__availability" >
                    <div class="block-brands__item-stock-available"></div>
                </div>
                <div class="product-card__check-stock" >
                    <div class="block-brands__item-check-stock">
                        <product-stock-display :stock-quantity="product.stockquantity" />
                        <div class="btn-check-stock" v-if="showCheckStock">
                            <router-link :to="'/order-entry-check-stock/' + product.manufacturer + '/' + clearProductName" class="btn btn-micro btn-dark-grey btn-check-stock" v-if="showCheckStock">Check Stock</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-card__footer">
                <div class="product-card__prices product-card__stock-text-search-whi-product-prices">
                    <div class="product-card__price product-card__price--current"><span class="notranslate">{{toUSD(product.extended_price)}}</span></div>
                    <!-- <div class="product-card__price product-card__price--old" v-if="product.list_price > 0">List: <span class="notranslate">{{toUSD(product.list_price)}}</span></div> -->
                    <div class="product-card__price product-card__price--core"  v-if="product.core_charge > 0">Core: <span class="notranslate">{{toUSD(product.core_charge)}}</span></div>
                </div>
            </div>
        </div>
    </div>
    <add-to-cart-dialog :open="hasAdded" @close="hasAdded = false" 
        :item_name="added_to_cart.item_name" 
        :item_image="added_to_cart.item_image"
        :quantity="added_to_cart.quantity">
    </add-to-cart-dialog>
</template>

<style scoped>
    /* .block-brands__item-alternates-available{ */
        /* margin-top: 0px; */
    /* } */

    .btn-dark-blue.btn-check-stock{
        padding: 3px  12px 3px 12px;
    }

    .search-results--bullets li{
        color: #000;
    }
</style>

<script>
    import Price from '../../../mixins/price.js';
    import MixinCart from '../../../mixins/cart.js';
    import ProductStockDisplay from '../../common/product/ProductStockDisplay.vue';
    import AddToCartDialog from '../../common/product/AddToCartDialog.vue';
    import { mapGetters } from 'vuex';
    import CloudinaryApi from '../../../utilities/cloudinaryapi';
    import * as GCONST from '../../../constants.js';
    import axiosvl from "../../../axios/axios-vl.js";

    export default {
        components: {
          "product-stock-display": ProductStockDisplay,
          "add-to-cart-dialog" : AddToCartDialog,
        },
        props : {
            product : {
                type : Object,
                required: true
            },
            sourcePage: {
                type: String
            },
            searchBy : {
                type : String
            },
            productValid : {
                type: Boolean
            },
            has_alternative: {
                type : String
            }
        },
        emits: [ 'open-smart-page-dialog', 'open-related-type' ],
        mixins : [
          Price,
          MixinCart,
        ],
        data() {
            return{
                quantity : 1,
                max_stars : 5,
                resource_img : null,

                // add to cart dialog properties
                hasAdded: false,
                added_to_cart : {
                    item_name: '',
                    quantity : 1,
                    item_image: '',
                },

                hasRelatedItems: false,
            };
        },
        computed: {
            ...mapGetters([
                'storeCatalog', 
                'customerIndicator',
                'storefrontAttributes'
            ]),
            showCheckStock() {
                if (this.storefrontAttributes.length > 0) {
                    let onHandQuantityRule = this.storefrontAttributes.find(attribute => attribute.indicator === this.customerIndicator && attribute.type === 'OHQ').value;
                    return this.customerIndicator === 'B' && onHandQuantityRule != '5' && this.product.stockquantity <= 0;
                } else {
                    return false;
                }
            },

            xref_mfgc() {
                const wd_mdfgs = this.$store.getters.wd_mfgxs;
                // console.log(this.product);
                if (this.product.XRMFGC != ''){
                    const xref_mfg_desc = wd_mdfgs.find(mfg => mfg.MFG_CODE == this.product.XRMFGC);
                    return xref_mfg_desc.MFG_DESC;
                }

                return '';
            },

            isValidOE() {
                const itemsku = this.product.sku;
                const lastL = itemsku.slice(-1);

                if(lastL == 'C' || lastL == 'N')
                    return true;
                else
                    return false;
            },

            isCapaCert() {
                // if product property is not existing yet
                // return false
                if (this.product.sku == undefined){
                    return false;
                }

                // get the last character of the product SKU
                const itemsku = this.product.sku;
                const isCapa = itemsku.slice(-1);

                if(isCapa == 'C')
                    return true;
                else
                    return false;
            },

            isNSFCert() {
                // if product property is not existing yet
                // return false
                if (this.product.sku == undefined){
                    return false;
                }

                // get the last character of the product SKU
                const itemsku = this.product.sku;
                const isCapa = itemsku.slice(-1);

                if(isCapa == 'N')
                    return true;
                else
                    return false;
            },

            clearProductName(){
                const clearProductName = encodeURIComponent(this.product.sku);

                return clearProductName;
            },

            isSearchResPage() {
                if (this.$route.name == "SearchResults"){
                    return true;
                }
                return false;
            }
        },
        watch: {
            product(part){
                // console.log(prod);
                this.getImage(part);
            }
        },
        methods: {
            openSmartPageDialog () {
              this.$emit('open-smart-page-dialog', this.product.smartpage_url);
            },
            addToCart() {
                this.$store.dispatch("message/clearKeyedMessage", this.sourcePage);
                let linetotal = 0;
    
                // if (this.$store.getters.customer != 'B2C') {
                //   linetotal = this.quantity * this.product.extended_price;
                // } else {
                linetotal = this.quantity * this.product.extended_price;
                const defaultLoc = this.$store.getters.getCustomerDetails;
                // console.log(defaultLoc);
                // }
                // console.log(this.product);
                // const test = true;
                // if(test){
                //     return false;
                // }

                // product.mfgSeo + '/' + product.itemSeo
                let productData = {
                    ID: this.product.sku,
                    item: this.product.sku,
                    desc: this.product.description,
                    manufacturer: this.product.manufacturer,
                    image: this.resource_img,
                    quantity: this.quantity,
                    listprice: this.product.list_price,
                    corecharge: this.product.core_charge,
                    yourprice: this.product.extended_price,
                    shipping: 0,
                    linetotal: linetotal,
                    mfgSeo: this.product.mfgSeo,
                    itemSeo: this.product.itemSeo,

                    // new fields
                    XRMFGC: this.product.XRMFGC,
                    XRITMC: this.product.XRITMC,
                    IMIGSA: this.product.IMIGSA,
                    IMISVALID: this.product.IMISVALID,
                    
                    stockquantity: this.product.stockquantity,
                    locationid: defaultLoc.defaultlocationid,
                    locationname: defaultLoc.defaultlocationname,
                    locationcity: defaultLoc.defaultlocationcity,
                    locationstate: defaultLoc.defaultlocationstate,
                }
                let validationresult = this.addToCartValidation(productData);
    
                if (validationresult.status === 'OK') {
                    this.$store.dispatch("cart/addToCart", productData);

                    this.added_to_cart = {
                        item_name: this.product.manufacturer + ' ' + this.product.description + ' ' + this.product.sku,
                        quantity : this.quantity,
                        item_image: this.resource_img,
                    }

                    this.hasAdded = true;
                } else {
                  let storedmessages = [];
                  storedmessages.push(validationresult.message);
    
                  this.$store.dispatch("message/addKeyedMessage", {
                    "key": this.sourcePage,
                    "messages": storedmessages
                  });
                }
                
            },

            goToRelated() {
                this.$emit('open-related-type', this.product);
            },

            setSmartPageURL(smart_url){

                if(!smart_url){
                    return;
                }
                
                this.$store.dispatch("product/setWhi_smart_url", smart_url);
                this.$router.push('/whi-product-detail');
            },

            setWHIProduct() {
                this.$store.dispatch("product/setWhi_product", this.product);
                this.$router.push('/whi-product-detail');
            },

            getImage(part) {
                const mfgs = this.$store.getters.mfgs_imgs;
                if (this.$route.name == "SearchResults"){
                    // WHI result item
                    if (this.storeCatalog === 'WHI'){
                        if(part.image != ''){
                            this.resource_img = part.image;    
                        }else{
                            const mfg = mfgs.find(m => (m.CL_MFGCODE == part.manufacturer));
                            if(mfg){
                                this.resource_img = mfg.CL_RESURL;
                            }else{
                                this.resource_img = GCONST.THUMB_IMAGE_PLACEHOLDER;
                            }
                        }
                    }
                    
                    // PARTSLINK ITEM
                    if (this.storeCatalog === 'PARTSLINK'){
                        const clApi = new CloudinaryApi;
                        clApi.item_sku = part.sku;
                        clApi.manufacturer_code = part.manufacturer;
                        
                        clApi.vlImageByMeta(GCONST.CL_METARTYPE_PARTSLINK, GCONST.Product_Thumbnail).then(imgURL => {
                            if(imgURL){
                                this.resource_img = imgURL;
                            }else{
                                this.resource_img = GCONST.IMAGE_PLACEHOLDER;
                            }
                        });
                    }
                }
            },

            getPartsLinkRelatedItems() {
                this.show = true;
                const manufacturer  = this.product.manufacturer;
                const itemsku  = this.product.QITEMC;
                this.related_items = [];

                // console.log(image);
                axiosvl.post(this.$store.getters['api/related_parts_uri'], {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },   
                        "fields": {
                            "EHCUST": { "value": this.$store.getters['customer'] },
                            "EIMFGC": { "value": manufacturer },
                            "EIITMC": { "value": itemsku },
                        },   
                    }
                })
                .then((response) => {
                    const fields = response.data.webroutine.fields;
                    const RPARTS = response.data.webroutine.lists.RPARTS.entries;
                    
                    if (fields.RESULTCOD.value === 'OK') {
                        if(RPARTS.length > 0){
                            this.hasRelatedItems = true;
                        }else{
                            this.hasRelatedItems = false;
                        }
                    }else{
                        this.isloading = false;
                    }
                })
                .catch((error) => {
                    console.log("error - " + error);
                });
            },
        },

        created() {
            console.log(this.product);

            const mfgs = this.$store.getters.mfgs_imgs;

            // if the page is KeywordSearchResults
            // search by wild card
            if ((this.$route.name == "KeywordSearchResults") || (this.$route.name == 'CategoryDrilldown')){
                if(this.product != undefined || this.product != null){
                    this.resource_img = this.product.image;

                    if(this.resource_img == ''){
                        const mfg = mfgs.find(m => (m.CL_MFGCODE == this.product.IMMFGC));
                        if(mfg){
                            this.resource_img = mfg.CL_RESURL;
                        }else{
                            this.resource_img = GCONST.THUMB_IMAGE_PLACEHOLDER;
                        }
                    }
                }else{
                    this.resource_img = GCONST.THUMB_IMAGE_PLACEHOLDER;
                }
            }

            // if the page is Search results or searching by WHI or Partslink
            if (this.$route.name == "SearchResults"){
                // WHI result item
                if (this.storeCatalog === 'WHI'){
                    if(this.product.image != ''){
                        this.resource_img = this.product.image;    
                    }else{
                        const mfg = mfgs.find(m => (m.CL_MFGCODE == this.product.manufacturer));
                        if(mfg){
                            this.resource_img = mfg.CL_RESURL;
                        }else{
                            this.resource_img = GCONST.THUMB_IMAGE_PLACEHOLDER;
                        }
                    }
                }
                
                // PARTSLINK ITEM
                if (this.storeCatalog === 'PARTSLINK'){
                    // this.getPartsLinkRelatedItems();
                    if(this.product.HASRELI == 'Y'){
                        this.hasRelatedItems = true;
                    }else{
                        this.hasRelatedItems = false;
                    }

                    const clApi = new CloudinaryApi;
                    clApi.item_sku = this.product.sku;
                    clApi.manufacturer_code = this.product.manufacturer;
                    
                    clApi.vlImageByMeta(GCONST.CL_METARTYPE_PARTSLINK, GCONST.Product_Thumbnail).then(imgURL => {
                        if(imgURL){
                            this.resource_img = imgURL;
                        }else{
                            this.resource_img = GCONST.IMAGE_PLACEHOLDER;
                        }
                    });
                }
            }
            console.table(this.product);
        },
        updated(){
            // console.log(this.product);
        }
    }
</script>